import React, {useState} from 'react';

import './preparation.scss';
import flsegdImg from './images/flsegdImg.png';
import {triggerYaEvent} from '../../../utils/yandex_counter';
import flscopyImg from './images/flscopyImg.png';
import flsoborvedImg from './images/flsoborvedImg.png';
import refregdImg from './images/refregdImg.png';
import refregfImg from './images/refregfImg.png';
import refpassImg from './images/refpassImg.png';
import refregaImg from './images/refregaImg.png';
import refdebt from './images/refdebtImg.png';
import housebookImg from './images/housebookImg.png';

const VIPISKA_SAMPLE = 'vipiska';
const ZHIL_DOC_SAMPLE = 'zhildoc';
const SPRAVKA_SAMPLE = 'spravka';
const FLSCOPY_SAMPLE = 'flscopy';
const FLSOBORVED_SAMPLE = 'flsoborved';
const REFREGD_SAMPLE = 'refregd';
const REFREGF_SAMPLE = 'refregf';
const REFPASS_SAMPLE = 'refpass';
const REFREGA_SAMPLE = 'refrega';

type SampleType =
        'vipiska'
        | 'zhildoc'
        | 'spravka'
        | 'refpass'
        | 'flsoborved'
        | 'flscopy'
        | 'refregf'
        | 'refrega';

interface DocSample {
    label: string;
    image: {
        src: string,
        srcSet: string,
    };
}

interface DocSamples {
    [VIPISKA_SAMPLE]: DocSample;
    [ZHIL_DOC_SAMPLE]: DocSample;
    [SPRAVKA_SAMPLE]: DocSample;
    [FLSCOPY_SAMPLE]: DocSample;
    [FLSOBORVED_SAMPLE]: DocSample;
    [REFREGD_SAMPLE]: DocSample;
    [REFREGF_SAMPLE]: DocSample;
    [REFPASS_SAMPLE]: DocSample;
    [REFREGA_SAMPLE]: DocSample;
}

const docSamples: DocSamples = {
    [VIPISKA_SAMPLE]: {
        label: 'Выписка из домовой книги',
        image: {
            src: housebookImg,
            srcSet: `${housebookImg} 2x, ${housebookImg} 3x`,
        },
    },
    [ZHIL_DOC_SAMPLE]: {
        label: 'Единый жилищный документ',
        image: {
            src: flsegdImg,
            srcSet: `${flsegdImg} 2x, ${flsegdImg} 3x`,
        },
    },
    [REFREGD_SAMPLE]: {
        label: 'Справка о регистрации с умершим на дату смерти по адресу',
        image: {
            src: refregdImg,
            srcSet: `${refregdImg} 2x, ${refregdImg} 3x`,
        },
    },
    [SPRAVKA_SAMPLE]: {
        label: 'Справка о наличии/отсутствии задолженности/переплаты',
        image: {
            src: refdebt,
            srcSet: `${refdebt} 2x, ${refdebt} 3x`,
        },
    },
    [REFPASS_SAMPLE]: {
        label: 'Справка о выданном паспорте',
        image: {
            src: refpassImg,
            srcSet: `${refpassImg} 2x, ${refpassImg} 3x`,
        },
    },
    [FLSCOPY_SAMPLE]: {
        label: 'Копия финансового лицевого счета',
        image: {
            src: flscopyImg,
            srcSet: `${flscopyImg} 2x, ${flscopyImg} 3x`,
        },
    },
    [REFREGF_SAMPLE]: {
        label: 'Справка о совместной регистрации по адресу',
        image: {
            src: refregfImg,
            srcSet: `${refregfImg} 2x, ${refregfImg} 3x`,
        },
    },
    [REFREGA_SAMPLE]: {
        label: 'Справка о регистрации по адресу/об отсутствии зарегистрированных по адресу',
        image: {
            src: refregaImg,
            srcSet: `${refregaImg} 2x, ${refregaImg} 3x`,
        },
    },
    [FLSOBORVED_SAMPLE]: {
        label: 'Оборотная ведомость по финансовому лицевому счету',
        image: {
            src: flsoborvedImg,
            srcSet: `${flsoborvedImg} 2x, ${flsoborvedImg} 3x`,
        },
    },
};

export function Preparation() {
    return (
            <div className="preparation">
                <div className="preparation__header">Как найти код или ID документа</div>

                <DocsSamples samples={docSamples}/>
            </div>
    );
}

const DocsSamples: React.FC<{ samples: DocSamples }> = ({samples}) => {
    const [activeType, setActiveType] = useState<SampleType>(VIPISKA_SAMPLE);

    const handleClickByType = (type: SampleType) => () => {
        triggerYaEvent('Клики по Как найти код', docSamples[type].label)
        setActiveType(type);
    };

    const buttons = getButtons({samples, activeType, handleClickByType});
    const {image} = samples[activeType];

    return (
            <>
                <div className="preparation__buttons">{buttons}</div>
                <div className="preparation__info">
                    <div className="preparation__image">
                        <img src={image.src} srcSet={image.srcSet} alt=""/>
                    </div>
                </div>
            </>
    );
};

function getButtons({
                        samples,
                        activeType,
                        handleClickByType,
                    }: {
    samples: DocSamples,
    activeType: SampleType,
    handleClickByType: (type: SampleType) => React.MouseEventHandler,
}) {
    const buttons = Object.keys(samples).map(type => (
            <DocsSampleButton
                    key={`key-sample-doc-button-${type}`}
                    label={samples[type as SampleType].label}
                    active={activeType === type}
                    handleClick={handleClickByType(type as SampleType)}
            />
    ));

    return <div className="doc-buttons">{buttons}</div>;
}

const DocsSampleButton: React.FC<{ label: string; active: boolean; handleClick: React.MouseEventHandler }> = ({
                                                                                                                  label,
                                                                                                                  active,
                                                                                                                  handleClick
                                                                                                              }) => {
    const styleActive = active ? '--active' : '';
    const classNames = ['doc-button', styleActive].join(' ');

    return (
            <div className={classNames} onClick={handleClick}>
                <div className="search-house-book__button">{label}</div>
            </div>
    );
}
